import styles from "./ExpertCard.module.scss";
import { FC } from "react";
import Image from "next/image";
import { H2, P3 } from "../../Typography";
import { Button } from "../../Buttons";
import { useTranslation } from "next-i18next";
import { FeedBackModalNew, modal } from "../../Modal";
import cl from "classnames";
import { IExpert } from "../../../../types/experts";
import { LeadType } from "../../../../types/lead-type";

type ExpertCardProps = {
  expert: IExpert;
  length: number;
  index: number;
  onMouseEnter: () => void;
  onMouseOut: () => void;
  onClick: () => void;
  type: "expert" | "specialist";
  classname?: string;
  isSingle?: boolean;
  leadType?: LeadType;
  modalTitle?: string;
  buttonLabel?: string;
  agreementText?: string;
  eventName?: string[];
};

export const ExpertCard: FC<ExpertCardProps> = ({
  expert,
  onMouseOut,
  onMouseEnter,
  onClick,
  type,
  classname,
  isSingle,
  leadType = "SALE",
  modalTitle,
  buttonLabel,
  agreementText,
  eventName = ["sale"]
}) => {
  const { t } = useTranslation("index", { keyPrefix: "landingVillas" });

  const openModal = (value: string) => {
    modal.open(
      <FeedBackModalNew
        title={modalTitle || (type === "expert" ? "getExpert" : "getSpecialist")}
        leadType={leadType}
        agreementText={agreementText}
        buttonLabel={buttonLabel}
        sourceForm="our experts form"
        comment={value}
        eventName={eventName}
      />,
      { isFeedBackNew: true },
    );
  };
  return (
    <div className={cl(styles.expertCard__wrapper, classname)} onClick={onClick}>
      <div
        className={cl(styles.expertCard, isSingle ? styles["expertCard--single"] : "")}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseOut}
      >
        <div className={styles.expertCard__content}>
          <div className={styles.expertCard__photo}>
            <Image
              width={343}
              height={317}
              loader={({ src }) => src}
              src={expert.image}
              sizes="100vw"
              alt={expert.name}
              className={cl(
                styles.expertCard__image,
                expert.mobileImage ? styles["expertCard__image--hidden"] : "",
              )}
              style={{ objectFit: "cover" }}
            />
            {expert.mobileImage && (
              <Image
                width={343}
                height={317}
                className={styles.expertCard__imageMobile}
                loader={({ src }) => src}
                src={expert.mobileImage}
                sizes="100vw"
                alt={expert.name}
                style={{ objectFit: "cover" }}
              />
            )}
          </div>
          <div className={styles.expertCard__info}>
            <H2>{t(expert.name)}</H2>
            <P3 className={styles.expertCard__info_description}>
              {t(expert.description)}
            </P3>
            <Button
              theme={"dark"}
              size={"lg"}
              as={"button"}
              label={t("connect")}
              className={styles.expertCard__info_button}
              onClick={() =>
                openModal(
                  `Запрос связи с менеджером по ${leadType === 'RENT' 
                    ? (expert.id === '1' ? 'аренде' : 'консьерж-сервису') 
                    : 'продаже'} ${expert.name}`
                  )
              }
            />
          </div>
        </div>
        <Image
          className={styles.expertCard__leaves}
          src={"/leaves/expert_bg.webp"}
          loader={({ src }) => src}
          sizes="100vw"
          width={917}
          height={1532}
          alt=""
        />
        <Image
          className={styles.expertCard__leavesMobile}
          src={"/leaves/expert_bg_mobile.webp"}
          loader={({ src }) => src}
          width={380}
          height={635}
          alt=""
          sizes="100vw"
        />
        <Image
          className={styles.expertCard__bg}
          fill
          src={"/images/club/bg.webp"}
          sizes="(min-width: 1640px) 1624px, (min-width: 1420px) 1352px, calc(95vw + 15px)"
          alt={""}
        />
      </div>
    </div>
  );
};
